import React from 'react';
import { Button as AntButton } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const SIZE_ALIASES = {
  sm: 'small',
  small: 'small',
  md: 'middle',
  middle: 'middle',
  lg: 'large',
  large: 'large',
};

// Normalize all incoming type names to the three canonical CSS classes.
const TYPE_NORMALIZE = {
  primary: 'primary',
  secondary: 'secondary',
  default: 'secondary',
  ghost: 'ghost',
  link: 'ghost',
  text: 'ghost',
};

const StandardButton = ({
  children,
  type = 'primary',
  variant,
  loading = false,
  disabled = false,
  danger = false,
  block = false,
  onClick,
  icon,
  size = 'middle',
  className = '',
  ...props
}) => {
  const { t } = useTranslation();

  const buttonText =
    typeof children === 'string' && children.includes('.') ? t(children) : children;

  const resolvedType =
    variant === 'ghost' ? 'ghost' : TYPE_NORMALIZE[type] || 'primary';
  const resolvedSize = SIZE_ALIASES[size] || 'middle';

  const classes = ['standard-button', `sb-${resolvedSize}`, `sb-${resolvedType}`];
  if (danger) classes.push('sb-danger');
  if (loading) classes.push('sb-loading');
  if (block) classes.push('sb-block');
  if (className) classes.push(className);

  return (
    <AntButton
      type="default"
      loading={loading}
      disabled={disabled}
      onClick={onClick}
      icon={icon}
      size={resolvedSize}
      block={block}
      className={classes.join(' ')}
      {...props}
    >
      {buttonText}
    </AntButton>
  );
};

StandardButton.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(['primary', 'secondary', 'ghost', 'link', 'text', 'default']),
  variant: PropTypes.oneOf(['solid', 'outline', 'ghost']),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  danger: PropTypes.bool,
  block: PropTypes.bool,
  onClick: PropTypes.func,
  icon: PropTypes.node,
  size: PropTypes.oneOf(['small', 'middle', 'large', 'sm', 'md', 'lg']),
  className: PropTypes.string,
};

export default StandardButton;
